import * as React from 'react';

// Fabric provides a Dialog that supports JSX. Pass this component to that Dialog as `title` when simple string dialog content does not meet your needs.
export const InternalDialogContent = (title: string, subText: JSX.Element) => {
  return (
    <div>
      <div style={{ paddingBottom: 20, fontSize: 20, fontWeight: 600 }}>{title}</div>
      <div>
        <div style={{ fontSize: 14, fontWeight: 400, lineHeight: 1.5, color: 'rgb(96, 94, 92)', overflowWrap: 'break-word' }}>{subText}</div>
      </div>
    </div>
  );
};
